import TipsContainer from './TipsContainer';

export default TipsContainer;
